export default {
  namespaced: true,
  state: () => ({ replayUrl: '' }),
  mutations: {
    setReplayUrl(state, replayUrl) {
      Object.assign(state, { replayUrl: replayUrl || '' })
    },
  },
}
